import { useEffect, useRef, useState } from "react";
import { CreditCard } from "lucide-react";
import api from "@/lib/api";

export default function PaymentForm({ plan }) {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current) return;
    mounted.current = true;
    (async () => {
      try {
        const { data: attempt } = await api.post("/payments/moyasar/attempt", { plan });
        if (!window.Moyasar) {
          setError("تعذر تحميل نموذج الدفع — تحقق من الاتصال ثم حدّث الصفحة");
          return;
        }
        window.Moyasar.init({
          element: ".mysr-form",
          amount: attempt.amount,
          currency: attempt.currency,
          description: `اشتراك ${attempt.label} — منصة راصد حضوري`,
          publishable_api_key: attempt.publishable_key,
          callback_url: `${window.location.origin}/payment/result`,
          methods: ["creditcard"],
          supported_networks: ["mada", "visa", "mastercard"],
          on_completed: async (payment) => {
            try {
              await api.post("/payments/moyasar/attach",
                { attempt_id: attempt.attempt_id, payment_id: payment.id });
            } catch { /* webhook/callback path will still verify by id */ }
          },
        });
      } catch (e) {
        setError(e.response?.data?.detail || "تعذر تجهيز الدفع، حدّث الصفحة وحاول مجدداً");
      } finally {
        setLoading(false);
      }
    })();
  }, [plan]);

  return (
    <div data-testid="moyasar-payment-form">
      {loading && <p className="text-sm text-slate-500 text-center py-4">جارٍ تجهيز نموذج الدفع الآمن...</p>}
      {error && (
        <p data-testid="payment-form-error"
          className="text-sm bg-rose-50 text-rose-700 border border-rose-200 rounded-lg px-3 py-2">{error}</p>
      )}
      <div className="mysr-form" dir="ltr" />
      <p className="text-[11px] text-slate-400 text-center mt-3 flex items-center justify-center gap-1">
        <CreditCard className="w-3.5 h-3.5" /> دفع آمن ومشفر عبر Moyasar — مدى / فيزا / ماستركارد
      </p>
    </div>
  );
}
